const tipsList = [
  {
    index: 1,
    content: [
      {
        options: [
          'Nicee是開放的虛擬服務交易平台，陪玩師可發揮想象空間，在合法範圍自由創建虛擬商品並自由定價能提供的服務。'
        ]
      }
    ]
  },
  {
    index: 2,
    content: [
      {
        options: [
          '技能介紹中如何展現自己，是促成第一單的關鍵',
          '請重視為對你下過單的所有客戶，他們將會是未來最客觀的收入來源',
          '在遊戲和交友類社媒中分享自己，能獲得大量精準、潛在客戶',
          '積極、樂天、富有感染力的心態，永遠都是你最珍貴資產'
        ]
      }
    ]
  },
  {
    index: 3,
    content: [
      {
        options: [
          '在用戶確認完成訂單后，平台將對資金來源進行風險評估，此時需要與銀行和金流方串接。只有在資金確認安全情況下才能入賬完成結算。按過往經驗，絕大部分款項結算在1-2天內完成，但如果資金來源在串接評估中報警，入賬將會產生延後。此時需要用戶積極與客服溝通，提供相應真誠接單材料，直至風險解除。當資金結算完成，陪玩師可進行提領，請確保實名信息與銀行賬戶一致，以確保官方正常打款。',
          '財務為統一流程，催促客服不會加快提領。'
        ]
      }
    ]
  },
  {
    index: 4,
    content: [
      {
        options: [
          '安全永遠放在第一位。開放的平台會遇到各種需求的用戶，請在有遇到威脅，或有損自身權益時，第一時間聯繫客服。提供真實、客觀、完整的相關溝通記錄和交易記錄，以便於官方進行處理。如有必要，官方會配合用戶與警方進行情況同步，但請勿在未握有明確證據或犯罪事實的情況下衝動行為或盲目報警。'
        ]
      }
    ]
  },
  {
    index: 5,
    content: [
      {
        options: [
          '參與詐騙、洗錢金融犯罪活動，屬於嚴重違法行為，平台將一律提告。對於直接參與者，平台將連同實名資料和行為情況移交法律；未直接參與但知情者，對於平台或他人利益損失，將根據平台用戶協議進行封號、停止結算和提領。'
        ]
      }
    ]
  },
  {
    index: 6,
    content: [
      {
        options: [
          '打造引力是新人開始必不可少的第一步。要相信自己永遠都是獨一無二最好的！'
        ]
      }
    ]
  }
];

export default tipsList;
